<template>
    <!-- TABS -->
    <div class="vx-col w-full p-0 pt-8" style="min-height: 500px;">
      <vs-tabs alignment="fixed" class="virtual-class--bottom-panel">

        <!--CLASS CONTENT FOR MOBILE TAB-->
        <vs-tab v-if="!isBigScreen"
          :label="$t('general.class-content')"
          icon="icon-list" icon-pack="feather"
          class="p-0"
        >
          <class-content
            :courseOutlineUnitLoading="courseOutlineUnitLoading"
            :courseOutlineUnits="courseOutlineUnits"
            :handlerStartTestClick="handlerStartTestClick"
            :handlerTopicClick="handlerTopicClick"
            :sidePanelActive="sidePanelActive"
            :student-enroll-detail="studentEnrollDetail"
            :triggerLoading="triggerLoading"
          >

          </class-content>
        </vs-tab>

        <!--OVERVIEW TAB-->
        <vs-tab
          :label="$t('virtual-class.description')"
          icon="icon-info" icon-pack="feather"
        >
          <div class="tab-text">
            <div class="vx-row">
              <div class="vx-col w-full sm:w-full lg:w-1/2">
                <subject-overview v-if="studentEnrollDetail"
                                  :student-enroll-detail="studentEnrollDetail">
                </subject-overview>
              </div>
              <div class="vx-col w-full sm:w-full lg:w-1/2">
                <teacher-profile-mini v-if="teacher"
                                 :teacher="teacher">
                </teacher-profile-mini>
              </div>
            </div>


            <subject-introduction v-if="studentEnrollDetail"
                                  :student-enroll-detail="studentEnrollDetail">
            </subject-introduction>
          </div>
        </vs-tab>

        <!--FAQ TAB-->
        <vs-tab :label="$t('general.faq')"
                icon="icon-help-circle" icon-pack="feather"
        >
          <FAQTab
            v-if="classSection"
            :classSection="classSection"
            :courseOutlineUnits="courseOutlineUnits"
            :currentFocusUnit="currentCourseOutlineUnit"
            :studentEnrollDetail="studentEnrollDetail"/>
        </vs-tab>

        <!--WEB BOARD TAB-->
        <vs-tab
          :label="$t('general.webboard')"
          icon-pack="feather" icon="icon-message-square"
        >
          <WebBoardTab v-if="classSection"
                       :student="student"
                       :studentEnrollDetail="studentEnrollDetail"
                       :classSection="classSection">
          </WebBoardTab>
        </vs-tab>

      </vs-tabs>
    </div>
</template>

<script>
import SubjectOverview from "../../ClassOverview/Components/SubjectOverview";
import SubjectIntroduction from "../../ClassOverview/Components/SubjectIntroduction";
import TeacherProfileMini from "@/views/pages/E-Learning/VirtualClass/BottomPanel/TeacherProfileMini";
import ClassContent from './ClassContent/index';

export default {
  props: [
    'studentEnrollDetail',
    'courseOutlineUnits',
    'student',
    'classSection',
    'teacher',
    'currentCourseOutlineUnit',

    'sidePanelActive',
    'courseOutlineUnitLoading',
    'handlerTopicClick',
    'handlerStartTestClick',
    'triggerLoading',
    'isBigScreen',
  ],
  components: {
    SubjectOverview,
    SubjectIntroduction,
    TeacherProfileMini,
    ClassContent,
    FAQTab: () => import("./Faq/index.vue"),
    WebBoardTab: () => import("./WebBoard/WebBoard.vue"),
  },
}
</script>

<style lang="scss">
.virtual-class--bottom-panel {
  & .vs-tabs--btn {
    text-align: center;
    justify-content: center;

    & .vs-icon {
      font-size: 1.6rem;
      text-align: left;
    }
  }
}
</style>
